import PropTypes from 'prop-types'

import {
  SectionTitle,
  CodeWrapper,
  CodeBlock
} from 'components/common/CodeBlock'
import theme from 'theme'

const UbuntuDebian = ({ colorTheme, ...rest }) => (
  <CodeWrapper {...rest}>
    <div css={{ paddingBottom: theme.space[2] }}>
      <div css={{ display: 'flex', alignItems: 'flex-end' }}>
        <SectionTitle colorTheme={colorTheme}>
          Add the Gremlin repo:
        </SectionTitle>
      </div>
      <CodeBlock
        code={
          'echo "deb https://deb.gremlin.com/ release non-free" | sudo tee /etc/apt/sources.list.d/gremlin.list'
        }
      />
    </div>

    <div css={{ paddingBottom: theme.space[2] }}>
      <div css={{ display: 'flex', alignItems: 'flex-end' }}>
        <SectionTitle colorTheme={colorTheme}>Import the GPG key:</SectionTitle>
      </div>
      <CodeBlock code="sudo apt-key adv --keyserver keyserver.ubuntu.com --recv-keys 9CDB294B29A5B1E2E00C24C022E8EF3461A50EF6" />
    </div>

    <div css={{ paddingBottom: theme.space[2] }}>
      <div css={{ display: 'flex', alignItems: 'flex-end' }}>
        <SectionTitle colorTheme={colorTheme}>
          Install Gremlin client and daemon:
        </SectionTitle>
      </div>
      <CodeBlock code="sudo apt-get update && sudo apt-get install -y gremlin gremlind" />
    </div>
  </CodeWrapper>
)

UbuntuDebian.propTypes = {
  colorTheme: PropTypes.oneOf(['light', 'dark'])
}

export default UbuntuDebian
